import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SPRITE_ID } from 'app/constants';

@Injectable({
    providedIn: 'root',
})
export class SpriteService {
    private http = inject(HttpClient);

    private spriteLoaded = new BehaviorSubject<boolean>(false);
    spriteLoaded$ = this.spriteLoaded.asObservable();

    constructor() {
        this.loadSprite();
    }

    private loadSprite() {
        if (document.getElementById(SPRITE_ID)) {
            this.spriteLoaded.next(true);
            return;
        }

        this.http.get('assets/images/sprite.svg', { responseType: 'text' }).subscribe((sprite) => {
            const div = document.createElement('div');
            div.id = SPRITE_ID;
            div.setAttribute('aria-hidden', 'true');
            div.style.position = 'absolute';
            div.style.width = '0';
            div.style.height = '0';
            div.style.overflow = 'hidden';
            div.innerHTML = sprite;

            // The fetched sprite's own root <svg> carries an inline display:none, which breaks
            // gradient/paint-server references (e.g. url(#...) fills) for icons pulled in
            // elsewhere via <use> in some browsers. The wrapper div above hides it visually
            // instead, so remove display:none from the sprite root to let those refs resolve.
            const spriteRoot = div.firstElementChild as SVGElement | null;
            spriteRoot?.style.removeProperty('display');

            document.body.insertBefore(div, document.body.firstChild);
            this.spriteLoaded.next(true);
        });
    }
}
